import Demos from '@/pages/Demos'

export default {
  path: '/demos',
  name: 'demos',
  component: Demos
}



// WEBPACK FOOTER //
// ./src/router/demos.js